export default __webpack_public_path__ + "static/PES2-8d4b98f59c0c20826ed985c63daf39d4.jpg";